import { useHistory, useParams } from 'react-router-dom';
import * as ImportDraft from 'components/imports/ImportDraft';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const Draft = () => {
    const history = useHistory();

    const { accountId } = useCurrentAccount();

    const { import_id } = useParams<{ import_id: string }>();
    const importId = parseInt(import_id);

    return (
        <ImportDraft.Root
            draftId={importId}
            open={true}
            onOpenChange={open => {
                if (!open) {
                    history.push(`/accounts/${accountId}/settings/imports/drafts`);
                }
            }}
        >
            <ImportDraft.Space />
        </ImportDraft.Root>
    );
};

export { Draft };
